import {
    PASSWORD_POLICY_MESSAGES,
    type PasswordPolicyContext,
    buildPasswordContextTerms,
    checkPasswordPolicy,
} from "@pentacode/core";

const REPEAT_MISMATCH_MESSAGE = "Die Passwörter stimmen nicht überein.";

/**
 * Inline validity for an input where a NEW password is chosen. Runs the same policy the server
 * enforces (length, context terms) with the same wording; only the breached-password blocklist stays
 * server-side and surfaces through the submit error instead.
 */
function validateNewPasswordInput(input: HTMLInputElement, context: PasswordPolicyContext = {}) {
    const violation = input.value
        ? checkPasswordPolicy(input.value, { contextTerms: buildPasswordContextTerms(context) })
        : null;
    input.setCustomValidity(violation ? PASSWORD_POLICY_MESSAGES[violation] : "");
}

export function validateNewPasswordInputs(
    passwordInput: HTMLInputElement,
    repeatInput: HTMLInputElement,
    context: PasswordPolicyContext = {}
) {
    validateNewPasswordInput(passwordInput, context);
    repeatInput.setCustomValidity(passwordInput.value === repeatInput.value ? "" : REPEAT_MISMATCH_MESSAGE);
}
